import { OverlayRef } from "@angular/cdk/overlay";
import { EventEmitter } from "@angular/core";

export class KontaktoplysningerPopupRef {
    public canceled = new EventEmitter<void>();
    public closed = new EventEmitter<void>();
    constructor(private overlayRef: OverlayRef) {}

    public close(): void {
        this.overlayRef.dispose();
        this.closed.emit();
    }

    public cancel(): void {
        this.overlayRef.dispose();
        this.canceled.emit();
    }
}
